import React from "react";
var __jsx = React.createElement;
import styles from './RecommendationSlider.module.css';
var RecommendationSliderSkeleton = function RecommendationSliderSkeleton() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: styles.cardItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imagePlaceholder
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.cardBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.titlePlaceholder
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.cardPrice
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.priceText
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tagWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  })))));
};
export default RecommendationSliderSkeleton;